import { ServiceTimeClass } from '@mews/enums';
import { createHandler } from '@mews/std';
import {
    DEFAULT_ARRIVAL_TIME_DAY,
    DEFAULT_ARRIVAL_TIME_HOUR,
    DEFAULT_ARRIVAL_TIME_MONTH,
    DEFAULT_ARRIVAL_TIME_NIGHT,
    DEFAULT_DEPARTURE_TIME_DAY,
    DEFAULT_DEPARTURE_TIME_HOUR,
    DEFAULT_DEPARTURE_TIME_MONTH,
    DEFAULT_DEPARTURE_TIME_NIGHT,
} from './constants';

const getDefaultArrivalTime = createHandler(
    {
        [ServiceTimeClass.Day]: DEFAULT_ARRIVAL_TIME_DAY,
        [ServiceTimeClass.Hour]: DEFAULT_ARRIVAL_TIME_HOUR,
        [ServiceTimeClass.Night]: DEFAULT_ARRIVAL_TIME_NIGHT,
        [ServiceTimeClass.Month]: DEFAULT_ARRIVAL_TIME_MONTH,
    },
    DEFAULT_ARRIVAL_TIME_NIGHT
);

const getDefaultDepartureTime = createHandler(
    {
        [ServiceTimeClass.Day]: DEFAULT_DEPARTURE_TIME_DAY,
        [ServiceTimeClass.Hour]: DEFAULT_DEPARTURE_TIME_HOUR,
        [ServiceTimeClass.Night]: DEFAULT_DEPARTURE_TIME_NIGHT,
        [ServiceTimeClass.Month]: DEFAULT_DEPARTURE_TIME_MONTH,
    },
    DEFAULT_DEPARTURE_TIME_NIGHT
);

export const getDefaulTimesByBookablePeriod = (bookablePeriod?: ServiceTimeClass) => ({
    arrivalTime: getDefaultArrivalTime(bookablePeriod),
    departureTime: getDefaultDepartureTime(bookablePeriod),
});
